var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6363 24.5745C45.6637 24.5969 46.6968 24.5292 47.7201 24.6097C48.7563 24.803 49.0061 26.3718 48.0855 26.8856C47.4573 27.224 46.7111 27.0116 46.0301 27.0713H44.6363V24.5745ZM48.3141 21.7485C48.5423 22.5542 47.7657 23.2775 46.9898 23.1666H44.6363C44.6528 22.4068 44.604 21.5822 44.6602 20.8624C45.603 20.889 46.5545 20.8083 47.4919 20.9046C47.8946 21.0058 48.2317 21.3369 48.3141 21.7485ZM53.978 9.80084C54.0218 11.3394 53.9844 12.9594 53.9969 14.5292C53.994 20.9115 54.0031 27.2936 53.9919 33.6762C53.9506 36.0681 51.8308 38.1465 49.4554 38.1943C47.0778 38.2039 44.6998 38.1958 42.3218 38.1984V28.5497C44.9127 28.5364 47.505 28.5769 50.0948 28.5295C51.2963 28.4541 52.6123 27.6613 52.6682 26.3392C52.8096 25.0113 51.5577 24.0929 50.3691 23.9478C49.9122 23.9359 49.9256 23.8146 50.3691 23.7617C51.5028 23.5167 52.393 22.3433 52.0595 21.1683C51.7752 19.9324 50.4092 19.454 49.273 19.4564C46.9563 19.4406 44.6391 19.4542 42.3223 19.4496C42.3372 17.6483 42.2911 15.8451 42.3472 14.0451C42.5307 11.6964 44.7039 9.75943 47.0459 9.80145C49.3569 9.8011 51.6676 9.8011 53.978 9.80101V9.80084Z",
    fill: "url(#paint0_linear_251_1084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1412 14.2886C16.2004 11.9004 18.3292 9.8391 20.7015 9.8042C23.0704 9.7969 25.4396 9.80314 27.8085 9.80103C27.802 17.7912 27.8214 25.7823 27.7988 33.772C27.7075 36.1311 25.6019 38.1531 23.2554 38.1949C20.882 38.2035 18.5084 38.1961 16.135 38.1985V28.2245C18.4404 28.7692 20.8579 29.001 23.2099 28.6398C24.6157 28.4136 26.1539 27.7232 26.6298 26.2646C26.9801 25.017 26.7829 23.704 26.835 22.4235V19.4498H22.7648C22.7465 21.4166 22.8023 23.3867 22.7354 25.3511C22.6257 26.5585 21.4299 27.3257 20.2912 27.2847C18.8789 27.2997 16.0803 26.2612 16.0803 26.2612C16.0733 22.5763 16.1213 17.9616 16.1412 14.2889V14.2886Z",
    fill: "url(#paint1_linear_251_1084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3264 20.6492C29.1121 20.6947 29.2833 19.9194 29.2285 19.6254C29.2431 17.766 29.198 15.9045 29.2534 14.0464C29.4365 11.6878 31.6263 9.74599 33.9778 9.8012H40.9026C40.8961 17.7914 40.9154 25.7824 40.8929 33.7721C40.8015 36.1313 38.6957 38.1532 36.3492 38.1951C33.9757 38.204 31.6021 38.1965 29.2284 38.1988V27.2709C30.8495 28.601 33.0527 28.808 35.0723 28.8116C36.5948 28.8111 38.1084 28.5764 39.587 28.2252V26.2232C37.9207 27.0537 35.962 27.5812 34.1149 27.104C32.8264 26.7833 31.8911 25.5381 31.912 24.2084C31.7627 22.8256 32.5732 21.3656 33.9321 20.9546C35.6193 20.4264 37.4581 20.8303 39.0396 21.517C39.3784 21.6945 39.7224 21.9145 39.5869 21.3482V19.7746C36.9419 19.1453 34.127 18.9137 31.4697 19.5983C30.7006 19.8153 29.9512 20.1443 29.3264 20.6494V20.6492Z",
    fill: "url(#paint2_linear_251_1084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_251_1084",
    x1: 42.2421,
    y1: 23.3925,
    x2: 53.9233,
    y2: 23.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_251_1084",
    x1: 15.8866,
    y1: 24.2717,
    x2: 27.6171,
    y2: 24.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_251_1084",
    x1: 29.2113,
    y1: 23.6679,
    x2: 40.9004,
    y2: 23.6679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbIcon);
export default __webpack_public_path__ + "static/media/jcb_icon.315b0f073ada0b7e567a0ce75a229fb0.svg";
export { ForwardRef as ReactComponent };